import React from "react";
import PropTypes from "prop-types";
import { Link, TextContainer } from "@shopify/polaris";
import { Banner } from "lib/components";

const ShopifyEmbeddedSuccess = ({ cms }) => (
  <div className="embedded-view-toast">
    <Banner isOpen status="success" title={cms("common.shopifyEmbedded.title")}>
      <TextContainer>
        <p>
          {cms("common.shopifyEmbedded.actionPrefix")}{" "}
          <Link url={cms("common.shopifyEmbedded.dashboardUrl")} external>
            {cms("common.shopifyEmbedded.linkText")}
          </Link>{" "}
          {cms("common.shopifyEmbedded.actionSuffix")}
        </p>
      </TextContainer>
    </Banner>
  </div>
);

ShopifyEmbeddedSuccess.propTypes = {
  cms: PropTypes.func.isRequired,
};

export default ShopifyEmbeddedSuccess;
